import service from "@/utils/requestDownload";


/**
 * 下载商品数据api
 */
export function downloadDataByBrandApi(data) {
    return service({
        url: '/download/brand',
        method: 'post',
        data
    })
}

/**
 * 下载商品数据api
 */
export function downloadDataByCustomizeApi(data) {
    return service({
        url: '/download/custom',
        method: 'post',
        data
    })
}

export function downloadConditionData(data) {
    return service({
        url: '/download/condition',
        method: 'post',
        data
    })
}
